import { Translatable } from "../common/types";

export const InkOnPaper :Translatable = {
    en: "Ink on paper",
    es: "Tinta sobre papel",
    jp: "紙にインク"
}
export const PencilOnPapel :Translatable = {
    en: "Graphite on paper",
    es: "Grafito sobre papel",
    jp: "紙にグラファイト"
}


export const WhiteCharcoal :Translatable = {
    en: "White charcoal on paper",
    es: "Carbón blanco sobre papel",
    jp: "紙に白木炭"
}

export const DigitalColor :Translatable = {
    en: "Digital coloring",
    es: "Coloreado digital",
    jp: "デジタル彩色"
}